// Generated code for Big.Domain.Enums.ProfessionalPositionApprovalType.
// Edit _Enum.tst to change the generated output.

export enum ProfessionalPositionApprovalType {
    unknown = 0,
    fully = 1,
    partially = 2
}
(ProfessionalPositionApprovalType as any).name = 'ProfessionalPositionApprovalType';
